import { Link } from "react-router";
import { AwardsMenu } from "@events-awards/utils/types";

type SideMenuProps = {
  /** The data of the navigation, will be displayed for mobile. */
  data: AwardsMenu[];
};

/**
 * Events Awards side menu component
 */
const SideMenu = ({ data }: SideMenuProps): React.ReactElement => {
  return (
    <nav
      data-testid="side-menu-component"
      className="my-5 flex flex-col bg-gray-250 text-center"
    >
      {data.map(({ link, text }, index) => {
        return (
          <Link
            key={`${text}${index}`}
            className="block px-3 py-2 font-public-sans text-base font-semibold text-gray-850 hover:bg-gray-175"
            to={link}
            reloadDocument
          >
            {text}
          </Link>
        );
      })}
    </nav>
  );
};

export default SideMenu;
